export class Location {

  static get fullFormat() {
    return 'h:mmA';
  }

  static get orderedDayMap() {
    return [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
  }

  static get easternTime() {
    // moment.tz.add('America/New_York|EST EDT|50 40|0101|1Lz50 1zb0 Op0');
    const easternTime = moment.tz('America/New_York');
    return easternTime;
  }

  static get localTime() {
    return moment();
  }

  static isOpen(location) {
    const nowInEasternTime = Location.easternTime;
    const currentDay = nowInEasternTime.day();
    const schedule = location[Location.orderedDayMap[currentDay]];
    if (!schedule) {
      return false;
    }
    const open = Location.getScheduleTime(currentDay, schedule.from);
    const close = Location.getScheduleTime(currentDay, schedule.to);

    return nowInEasternTime.isBetween(open, close) || open.isSame(close);
  }

  static getScheduleTime(day, seconds) {
    return Location.easternTime
      .day(day)
      .startOf('day')
      .add(seconds, 'second');
  }
  static getScheduleLocalTime(day, seconds) {
    return Location.getScheduleTime(day, seconds)
      .utcOffset(Location.localTime.utcOffset());
  }

  static getNearestDayWithOpening(location, fromDay) {
    let nextDayWithOpening = fromDay;
    for (let i = 0; i < 7; i++) {
      if (location[Location.orderedDayMap[nextDayWithOpening]]) {
        return nextDayWithOpening;
      }
      if (nextDayWithOpening < 6) {
        nextDayWithOpening++;
      } else {
        nextDayWithOpening = 0;
      }
    }
    return -1;
  }

  /**
   * Cases:
   *   - Location is open on current day
   *     - and location is open 24h for current day
   *       - and next close time is at *next day* closing time
   *     - and current time is < open time
   *       - and next open time is today at open time
   *     - and current time is > close time
   *       - and next open time is on next open day at next open day's open time
   *     - and current time is between open and close time
   *       - and location closes at close time
   *   - Location is closed on current day
   *     - and next open time is on next open day at next open day's open time
   *   - Location has no schedule information
   * @param location
   * @returns {string}
   */
  static renderCurrentDaySchedule(location) {
    let isLocationDetailPage = $('.location-detail');
    const template = (isLocationDetailPage.length) ?  vars => `<div class="current">${vars.open}<span class="message">${vars.message}</span></span><button id="schedule" class="hours-toggle"><i class="icon-caret"></i></button></div>` :
      vars => `<div class="current">${vars.open}<span class="message">${vars.message}</span></span></div>`;

    const nowInEasternTime = Location.easternTime;
    const nowInLocalTime = Location.localTime;
    const currentDay = nowInEasternTime.day();


    let nextOpenDay = Location.getNearestDayWithOpening(location, currentDay);
    if (nextOpenDay === -1) {
      return;
    }

    if (nextOpenDay !== currentDay) {
      const nextOpen = nowInEasternTime
        .clone()
        .startOf('day')
        .add(nextOpenDay < currentDay ? 7 - currentDay + nextOpenDay : nextOpenDay - currentDay, 'day')
        .add(location[Location.orderedDayMap[nextOpenDay]].from, 'second');
      return template({
        open: '<span class="closed">Closed</span>',
        message: `Opens ${nextOpen.format(Location.fullFormat)}.`,
      });
    } else {
      const scheduleForDay = location[Location.orderedDayMap[nextOpenDay]];
      if (scheduleForDay.from === scheduleForDay.to) {
        return template({
          open: '<span class="open">Open</span>',
          message: `24 Hours`,
        });
      }
      const open = nowInEasternTime
        .clone()
        .startOf('day')
        .add(scheduleForDay.from, 'second');
      const close = nowInEasternTime
        .clone()
        .startOf('day')
        .add(scheduleForDay.to, 'second');
      if (nowInEasternTime.isBetween(open, close)) {
        const closesAt = close
          .clone();
        return template({
          open: '<span class="open">Open</span>',
          message: `Closes ${Location.formatTime(closesAt)}`,
        });
      } else if (nowInEasternTime.isBefore(open)) {
        const openAt = open
          .clone();
        return template({
          open: '<span class="closed">Closed</span>',
          message: `Opens ${Location.formatTime(openAt)}`,
        });
      } else if (nowInEasternTime.isAfter(close)) {
        nextOpenDay = Location.getNearestDayWithOpening(location, nextOpenDay < 6 ? nextOpenDay + 1 : 0);
        const nextOpen = nowInEasternTime
          .clone()
          .startOf('day')
          .add(nextOpenDay < currentDay ? 7 - currentDay + nextOpenDay : nextOpenDay - currentDay, 'day')
          .add(location[Location.orderedDayMap[nextOpenDay]].from, 'second');
        return template({
          open: '<span class="closed">Closed</span>',
          message: `Opens ${nextOpen.format(Location.fullFormat)}`,
        });
      } else {
        throw 'Shouldn\'t get here.';
      }
    }
  }

  static formatTime(time) {
    let meridiem = 'AM';
    let format = 'h:mm';
    if (time.hours() >= 11) {
      meridiem = 'PM';
    }
    return `${time.format(format)} ${meridiem}`;
  }
}
